/* eslint-disable */
const getDefaultState = () => {
  return {
    windowWidth: window.innerWidth,
    bodyHeight: document.body.scrollHeight - 75,

    isLoading: false,
    loadingCount: 0,
    hideDelayTimeout: null,

    is_embedded_in_mh_app: false,
  }
}

const state = getDefaultState()

const getters = {
}

const mutations = {
}

const actions = {
  startLoading(context) {
    context.state.loadingCount++;
    if (context.state.hideDelayTimeout) {
      clearTimeout(context.state.hideDelayTimeout);
      context.state.hideDelayTimeout = null;
    }
    context.state.isLoading = true;
  },
  stopLoading(context) {
    if (context.state.loadingCount > 0) {
      context.state.loadingCount--;
    }
    if (context.state.loadingCount === 0) {
      context.state.hideDelayTimeout = setTimeout(() => {
        context.state.isLoading = false;
        context.state.hideDelayTimeout = null;
      }, 0);
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
